<script lang="ts" setup>
defineProps<{ data: string }>()
</script>

<template>
  <section v-if="data" class="htmldescription" data-allow-mismatch v-html="data" />
</template>
